import { SyncStorage } from "../cutil/SyncStorage";
export class StorageManager extends SyncStorage {
}
